import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AUTOGENERATED_NAME_TEXT, EXPERIMENT_NAME_MAX_LENGTH} from 'studies/StudyConstants';
import {getProcedureRunUIStringForStudyType} from 'studies/TypedStudyUtils';
import FormGroup from 'ui-library/bs/FormGroup';
import {InputErrorMessageStyle} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

export default function ExperimentNameField(props: {
  contextLocked: boolean;
  experimentName: string | null;
  setExperimentName: (experimentName: string | null) => void;
  isNameAutogenerated: boolean;
  studyType: StudyType;
}): JSX.Element {
  const initialExperimentName = props.experimentName ?? '';
  const displayValue = props.isNameAutogenerated ? AUTOGENERATED_NAME_TEXT : initialExperimentName;
  const isDisabled = props.contextLocked || props.isNameAutogenerated;
  const isRequired = !props.contextLocked && !props.isNameAutogenerated;
  const isOverLimit = !props.isNameAutogenerated && initialExperimentName.length > EXPERIMENT_NAME_MAX_LENGTH;

  return (
    <FormGroup>
      <TextField
        label={`${getProcedureRunUIStringForStudyType(props.studyType, {capital: true})} name`}
        placeholder={`New ${getProcedureRunUIStringForStudyType(props.studyType)} name`}
        isRequired={isRequired}
        disabled={isDisabled}
        value={displayValue}
        error={
          isOverLimit
            ? {
                message: `${getProcedureRunUIStringForStudyType(props.studyType, {capital: true})} name must be less than or equal to ${EXPERIMENT_NAME_MAX_LENGTH} characters.`,
                style: InputErrorMessageStyle.ERROR,
              }
            : undefined
        }
        hasError={isOverLimit}
        onChange={(name) => {
          props.setExperimentName(name.target.value);
        }}
        dataTestAttrs={{component: 'AddExperimentModal', element: 'experimentNameInput'}}
      />
    </FormGroup>
  );
}
